export const stripTags = (val: string) => {
  return val.replace(/(<([^>]+)>)/gi, "");
}

export const stripTagsForID = (val: string) => {
  return val.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "-").replace(/\./g, "-").toLowerCase();
}
